import * as PropTypes from 'prop-types'
import React from 'react'

import { HighlightedText, Link, TextTypeWriter } from '../../../components'
import { chainDecorators, memoized } from '../../../utils/ReactUtils'

import styles from './styles'


const decorators = [
  memoized,
]

function HomeContact(props) {
  const { title, contactEmail } = props

  return (
    <section className="contact">
      <Link
        className="content"
        link={`mailto:hello@big-boss-studio.com`}
      >
        <h1 className="baseline">
          <TextTypeWriter strings={title.split('|')} />
        </h1>
        <div className='arrow'><img width={35} height={30} src={'/images/icons/arrow-right-white.svg'} alt={'next'} /></div>
      </Link>
      <style jsx>{styles}</style>
    </section>
  )
}

HomeContact.propTypes = {
  title: PropTypes.string,
  contactEmail: PropTypes.string,
}

HomeContact.defaultProps = {
  title: '',
  contactEmail: '',
}

HomeContact = chainDecorators(decorators, HomeContact)

export default HomeContact
